import { RESET_STORE, SET_VEHICLES_VENDORS_LIST_IN_STORE } from "../actions/types";

const INITIAL_STATE = {
    vendors: {}
};
const VehicleVendorReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_VEHICLES_VENDORS_LIST_IN_STORE: {
            return {
                ...state,
                vendorsList: action.data
            }
        }
        case RESET_STORE: {
            return INITIAL_STATE;
        }
        default: return state;
    }
};

export default VehicleVendorReducer;